import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Modal extends Component {
	modalOutsideClicked = (e) => {
		// e.preventDefault()
		if(!this.modalClickedInside) {
			// Only outside clicked, dismiss the modal
			this.props.modalDismissed()
		}
		this.modalClickedInside = false
	}

	modalInsideClicked = (e) => {
		// e.preventDefault()
		this.modalClickedInside = true
	}

	render() {
		return (
			<div className={this.props.display ? 'popup' : 'popup hidden'} onClick={this.modalOutsideClicked}>
				<div className="modal" onClick={this.modalInsideClicked}>
					{this.props.children}
				</div>
				<div className="modalX">
					&#10005;
				</div>
			</div>
		)
	}
}

Modal.propTypes = {
	children: PropTypes.element.isRequired,
	display: PropTypes.bool.isRequired,
	modalDismissed: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/Modal.js